// Small Glamzy Lookbook helpers used in the browser (kept apart from the look data in fashionLibrary.js)

export const TYPES = [
  { id: "Event", label: "Events & holidays" },
  { id: "Trend", label: "Trends & aesthetics" },
  { id: "Love", label: "Love & dates" },
  { id: "Fantasy", label: "Fantasy" },
];

// "Witchy Moon Look" -> "Witchy Moon"; a two-word name like "Beach Look" stays as it is
export const shortTitle = (title) => (title.split(" ").length > 2 ? title.replace(/ Look$/, "") : title);

// "Mon, Nov 2" style date for labels
export function niceDate(iso) {
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });
}
